// FILE: src/pages/admin/SchoolEditorPage/SchoolEditorPage.tsx
// Part 1: Imports and State Setup

import {
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  Grid,
  IconButton,
  LinearProgress,
  List,
  ListItem,
  ListItemSecondaryAction,
  ListItemText,
  Tooltip,
  Typography,
} from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import { Delete, Edit, Link as IconLink } from "@material-ui/icons";
import EmailValidator from "email-validator";
import update from "immutability-helper";
import { cloneDeep } from "lodash";
import * as React from "react";
import { Link, Prompt } from "react-router-dom";
import Modal from "src/components/Modal";
import CloseIcon from "@material-ui/icons/Close";
import {
  ICoach,
  IDirectorParams,
  ISchool,
  ISchoolData,
  ITemplate,
} from "src/services";
import Component from "../../../components/Component";
import Page from "../../../components/Page";
import PartialCleanCheck from "../../../components/PartialCleanCheck";
import withAppContext from "../../../components/withAppContext";
import withAxios from "../../../components/withAxios";
import {
  DIRECTORS_HEADING,
  DIRECTOR_ADD_EMAIL,
  DIRECTOR_DELETE_TOOLTIP,
  DIRECTOR_EDIT_TOOLTIP,
  GET_MODAL_SUBTITLE,
  LOGO_1_INPUT_LABEL,
  MASCOT_INPUT_LABEL,
  MASCOT_INPUT_PLACEHOLDER,
  MODAL_ALLOWED_COACHES,
  MODAL_CHECK_ALL,
  MODAL_CLOSE,
  MODAL_TITLE,
  MODAL_UNCHECK_ALL,
  PRIMARY_COLOR_INPUT_LABEL,
  SECONDARY_COLOR_INPUT_LABEL,
  SLUG_INPUT_LABEL,
  SLUG_INPUT_PLACEHOLDER,
  SUBMIT,
  TAGLINE_INPUT_LABEL,
  TAGLINE_INPUT_PLACEHOLDER,
  TEMPLATES_BODY,
  TEMPLATES_HEADING,
  TEMPLATE_DELETE_TOOLTIP,
  TEMPLATE_LINK_TOOLTIP,
  UNSAVED_CHANGES_PROMPT,
  UPDATE,
} from "./constants";
import { styles } from "./styles";
import { IProps, ISchoolEditorState } from "./types";
import { APP_LOGO_BASE64 } from "src/constants";
import { IMainAdEdit } from "./types";
import SubscriptionUpgradeModal from "src/components/SubscriptionUpgradeModal";

export default withAppContext(
  withStyles(styles)(
    withAxios(
      class SchoolEditorPage extends Component<IProps, ISchoolEditorState> {
        private partialCleanCheck: PartialCleanCheck<ISchoolEditorState> =
          new PartialCleanCheck(this, [
            "directors",
            "name",
            "primaryColor",
            "secondaryColor",
            "slug",
            "tagline",
            "templates",
            "imageChanged",
            "mascot",
            "isMidSeason"
          ]);

        // private readonly handleLogo1Change = this.handleImageUploadAsync(
        //   (result) => ({
        //     imageChanged: true,
        //     logo1: result,
        //   })
        // );

        private readonly handleNameChange = this.stateInputEventHandler(
          (v) => ({ name: v })
        );
        private readonly handleMascotChange = this.stateInputEventHandler(
          (v) => ({ mascot: v })
        );
        private readonly handleTaglineChange = this.stateInputEventHandler(
          (v) => ({ tagline: v })
        );
        private readonly handleSlugChange = this.stateInputEventHandler((v) => {
          const trimmedSlug = v.trim();      
          if (!trimmedSlug) {
              this.setState({ slugExist: false });
              return { slug: "" };
          }      
          const slugExists = this.state.AllSlugs?.includes(trimmedSlug);
          this.setState({ slugExist: slugExists });
          return { slug: trimmedSlug.replace(/\s/, "") };
        });
           
        private readonly handlePrimaryChange = this.stateInputEventHandler(
          (v) => ({ primaryColor: v })
        );
        private readonly handleSecondaryChange = this.stateInputEventHandler(
          (v) => ({ secondaryColor: v })
        );

        constructor(props: IProps) {
          super(props);
          this.state = {
            coaches: [],
            directorEmail: "",
            adfirstName:"",
            adlastName:"",
            directors: [],
            mainAd:[],
            editModalDirectorIndex: -1,
            imageChanged: false,
            isEditModalOpen: false,
            adEditModal:false,
            loadedSlug: "",
            logo1: APP_LOGO_BASE64,
            logo2: APP_LOGO_BASE64,
            name: "",
            primaryColor: "#494b8f",
            secondaryColor: "#ffffff",
            slug: "",
            tagline: "",
            templateId: -1,
            templates: [],
            mascot: "",
            isMidSeason: false,
            isADschool: false,
            directorAdded: false,
            AllSlugs: [],
            slugExist: false,
            showEnable: false,
            ismidseasonOnly: false,
            schoolData:"",
            openUpgrade: false,
            newSchool: undefined as any
          };
          this.partialCleanCheck.setOldFormData(this.state);
        }

        // Helper: extract only the fields PartialCleanCheck cares about
        public getPartialCleanState = () => {
          const {
            directors,
            name,
            primaryColor,
            secondaryColor,
            slug,
            tagline,
            templates,
            imageChanged,
            mascot,
            isMidSeason,
          } = this.state;
          return {
            directors,
            name,
            primaryColor,
            secondaryColor,
            slug,
            tagline,
            templates,
            imageChanged,
            mascot,
            isMidSeason,
          };
        };

        public componentDidMount() {
          this.getAllSlug();
          this.loadSchool(this.props.schoolId);
          this.props.loadSchools();
        }

             public readonly handleLogo1Change = async (event: React.ChangeEvent<HTMLInputElement>) => {
  const file = event.target.files?.[0];

  // VALIDATION
  if (!file) {return;}

  // Only image files allowed
  if (!file.type.startsWith("image/")) {
    alert("Please upload an image file only.");
    event.target.value = "";
    return;
  }

  //  Max 2MB size limit
  const MAX_SIZE_MB = 5;
  const MAX_BYTES = MAX_SIZE_MB * 1024 * 1024;

  if (file.size > MAX_BYTES) {
    alert(`Image too large! Maximum allowed size is ${MAX_SIZE_MB} MB.`);
    event.target.value = "";
    return;
  }

  //  SAME OLD LOGIC (do not change this)
  const originalHandler = this.handleImageUploadAsync((result) => ({
    imageChanged: true,
    logo1: result,
  }));

  return originalHandler(event);
};
        public async getAllSlug() {
          const AllSchoolSlug: any = await this.buildGet(
            this,
            `school/getAllSchoolSlug`
          )();
          if (AllSchoolSlug?.data?.length > 0) {
            const arr:any = [];
            AllSchoolSlug?.data?.map((item:any)=>{
             arr?.push(item?.slug);
            });
            this.setState({ AllSlugs: arr });
          }
        }
      
        public componentDidUpdate(_: IProps, prevState: ISchoolEditorState) {
          const prevSlug = prevState.school?.slug;
          const currentSlug = this.state.school?.slug;
          const slugChanged = prevSlug !== currentSlug;
          if (slugChanged && currentSlug !== "") {
            this.loadCoaches(currentSlug!);
          }
        }
public render() {
          const {
            appContext: { baseUri },
            classes,
          } = this.props;
          const {
            loading,
            logo1,
            primaryColor,
            secondaryColor,
            name,
            tagline,
            slug,
            loadedSlug,
            postingSchool,
            mascot,
          } = this.state;

          const isNewSchool = this.props.schoolId === undefined;

          return (
            <Page header="School Editor">
              <Prompt
                when={
                  !this.partialCleanCheck.isClean() &&
                  postingSchool === undefined
                }
                message={UNSAVED_CHANGES_PROMPT}
              />

              <form className={classes.formdev}>
                <div className={classes.updatebtn}>
                  <div className={classes.spanlink}>
                    {loadedSlug === "" ? null : (
                      <span>
                        School Link:{" "}
                        <a target="_blank" href={`${baseUri}/${loadedSlug}`}>
                          /{loadedSlug}
                        </a>
                      </span>
                    )}
                  </div>
                  <div>
                    {loading && <LinearProgress />}
                    <Button
                      onClick={() => {
                        if (this.canSubmit(isNewSchool)) {
                          if (isNewSchool) {
                            this.submitSchool();
                          } else {
                                                        // If you want to open upgrade for existing school do it here,
                            // but do NOT open modal unconditionally — mark form clean first.
                            // this.partialCleanCheck.setOldFormData(this.getPartialCleanState());
                            // Only update; do NOT open the upgrade modal for existing schools
                            this.updateSchool();
                          }
                        }
                      }}
                      style={{
                        marginTop: "10",
                        backgroundColor: "#494b8f",
                        color: "#ffffff",
                        cursor: "pointer",
                      }}
                      variant="contained"
                      color="primary"
                    >
                      {isNewSchool ? SUBMIT : UPDATE}
                    </Button>
                  </div>
                </div>
                
                <div className={classes.allnameflex}>
                  <div className={classes.labelflex}>
                    <label className={classes.labelcolor}>Name:<span style={{color:"red"}}>*</span></label>
                    <br />
                    <input 
                      value={name} 
                      onChange={this.handleNameChange} 
                      className={classes.inputboxis} 
                    />
                  </div>
                  <div className={classes.labelflex}>
                    <label className={classes.labelcolor}>
                      {TAGLINE_INPUT_LABEL}
                    </label>
                    <br />
                    <input
                      className={classes.inputboxis}
                      placeholder={TAGLINE_INPUT_PLACEHOLDER}
                      value={tagline}
                      onChange={this.handleTaglineChange}
                    />
                  </div>
                </div>
                
                <div className="slug-mascot">
                  <div className="slug-innder">
                    <label className={classes.labelcolor}>
                      {SLUG_INPUT_LABEL}<span style={{color:"red"}}>*</span>
                      <span className={classes.unavailable}>
                        {slug === "" || this.uniqueSlug() ? "" : " "}
                      </span>
                    </label>
                    <br />
                    <input
                      className={classes.inputboxis}
                      placeholder={SLUG_INPUT_PLACEHOLDER}
                      value={slug}
                      onChange={this.handleSlugChange}
                      disabled={isNewSchool ? false : true}
                    />
                    <span style={{ color: "red", display:"block" }}>
                      {this.state.slugExist === true && "Slug already exists."}
                    </span>
                  </div>
                  <div className={classes.labelflex}>
                    <label className={classes.labelcolor}>
                      {MASCOT_INPUT_LABEL}<span style={{color:"red"}}>*</span>
                    </label>
                    <br />
                    <input
                      className={classes.inputboxis}
                      placeholder={MASCOT_INPUT_PLACEHOLDER}
                      value={mascot}
                      onChange={this.handleMascotChange}
                    />
                  </div>
                </div>
                
                <div className={classes.allnameflex1}>
                  <div className={classes.logo1divs}>
                    <label className={classes.logo1lable}>
                      <img id="target" src={logo1} className={classes.image} />
                    </label>
                    <br />
                    <h4 style={{ fontSize: "15px" }}>{LOGO_1_INPUT_LABEL}</h4>
                    <input
                      className={classes.inputlogo1}
                      id="logo1"
                      name="logo1"
                      type="file"
                      onChange={this.handleLogo1Change}
                      accept="image/*"
                      style={{ position: "relative", right: "60px" }}
                    />
                  </div>
                </div>
                
                <div className={classes.primarysec}>
                  <div className={classes.primary}>
                    <label className={classes.labelcolor}>
                      {PRIMARY_COLOR_INPUT_LABEL}
                    </label>
                    <br />
                    <input
                      className={classes.primaryinputcolor}
                      placeholder={primaryColor}
                      value={primaryColor}
                      onChange={this.handlePrimaryChange}
                    />
                    <input
                      className={classes.colorprimary}
                      style={{ position: "relative", top: "8px" }}
                      type="color"
                      name="primaryColor"
                      value={
                        this.validHexColor(this.state.primaryColor)
                          ? this.state.primaryColor
                          : "#ffffff"
                      }
                      onChange={this.handlePrimaryChange}
                    />
                  </div>
                  <div className={classes.secondary}>
                    <label className={classes.labelcolor}>
                      {SECONDARY_COLOR_INPUT_LABEL}
                    </label>
                    <br />
                    <input
                      className={classes.primaryinputcolor}
                      placeholder={secondaryColor}
                      value={secondaryColor}
                      onChange={this.handleSecondaryChange}
                    />
                    <input
                      className={classes.colorprimary}
                      style={{ position: "relative", top: "8px" }}
                      type="color"
                      name="secondaryColor"
                      value={
                        this.validHexColor(this.state.secondaryColor)
                          ? this.state.secondaryColor
                          : "#ffffff"
                      }
                      onChange={this.handleSecondaryChange}
                    />
                  </div>
                </div>
                
                {this.renderDirectors()}
                {this.renderTemplates()}
              </form>

              {/* ✅ SUBSCRIPTION UPGRADE MODAL */}
              {this.state.openUpgrade && (
                <SubscriptionUpgradeModal
                  axios={this.props.axios}
                  open={this.state.openUpgrade}
                  onClose={() => {
                    // User closed modal without submitting
                    // mark tracked fields clean before navigating so Prompt won't block
                    this.partialCleanCheck.setOldFormData(this.getPartialCleanState());
                    this.setState({ openUpgrade: false }, () => {
                      this.props.history.push(`/admin/schools`);
                    });
                  }}
                  selectedRow={this.state.newSchool}
                  onUpgradeSubmit={async () => {
                    // User successfully submitted upgrade
                    // mark tracked fields clean before navigating so Prompt won't block
                    this.partialCleanCheck.setOldFormData(this.getPartialCleanState());
                    this.setState({ openUpgrade: false }, () => {
                      this.props.loadSchools();
                      this.props.history.push(`/admin/schools`);
                    });
                  }}
                />
              )}
            </Page>
          );
        }

        // CONTINUE TO PART 2...

        // FILE: src/pages/admin/SchoolEditorPage/SchoolEditorPage.tsx
// Part 2: Key Methods (submitSchool with Modal Integration)

        // CRITICAL METHOD: submitSchool with Modal Integration
        private submitSchool: () => undefined = () =>
          void this.runCancellableStatefulAsync(
            this,
            {
              postingSchool: true,
              submitting: true,
            },
            {
              postingSchool: undefined,
              submitting: undefined,
            },
            async () => {
              const {
                name,
                primaryColor,
                secondaryColor,
                slug,
                tagline,
                templates,
                logo1,
                logo2,
                mascot
              } = this.state;

              const schoolTemplates = templates
                .map((template) =>
                  this.props.templates.find((t) => t.id === template.id)
                )
                .filter((template) => template != null) as ITemplate[];

              // 1. Create the school
              const schoolResponse = await this.buildPost<
                ISchoolData & {isMidSeason: boolean} & {isAdSurveyStatus:boolean} & {isAdSurvey: boolean},
                ISchool | { id?: number } | { status?: boolean; data?: any }
              >(
                this,
                "school"
              )({
                directors: this.state.directors
                  .map(({ email, restrictedCoaches, adfName, adlName }) => ({
                    email: email.trim().toLowerCase(),
                    firstName: adfName,
                    lastName: adlName,
                    restrictedCoaches,
                  }))
                  .filter(({ email }) => Boolean(email)),
                logo1: logo1 === "" ? APP_LOGO_BASE64 : logo1,
                logo2: logo2 === "" ? APP_LOGO_BASE64 : logo2,
                name: name.trim(),
                primaryColor: primaryColor === "" ? "#494b8f" : primaryColor,
                secondaryColor: secondaryColor === "" ? "#ffffff" : secondaryColor,
                slug: slug.trim(),
                tagline: tagline.trim(),
                templates: schoolTemplates,
                mascot,
                isMidSeason: this.state.isMidSeason,
                isAdSurveyStatus: false,
                isAdSurvey: false,
              });

              // 2. Only use the ID from the direct response (do not update any other school)
              const responseAny: any = schoolResponse as any;

              console.log("Create school response:", responseAny);
              
              const newSchoolId = responseAny?.data?.school?.id
              if (!newSchoolId) {
                alert("Failed to create school: No ID returned.");
                this.setState({ postingSchool: undefined, submitting: undefined });
                return;
              }

              // 3. Only update the newly created school
              try {
                await this.updateCreatedSchoolDirectors(newSchoolId);
              } catch (error) {
                alert("School created but failed to assign school administrators. Please edit school and save again.");
                this.props.history.push(`/admin/schools/edit/${newSchoolId}`);
                return;
              }

              // 4. Open upgrade modal as before (membership id logic can be kept if needed)
              let resolvedMembershipId: number = Number(
                responseAny?.membership_id ??
                  responseAny?.membershipId ??
                  responseAny?.memberShipId ??
                  responseAny?.membership?.id ??
                  responseAny?.data?.membership_id ??
                  responseAny?.data?.membershipId ??
                  responseAny?.data?.memberShipId ??
                  responseAny?.data?.membership?.id ??
                  0
              );

              let schoolDetailsRes: any;
              if (resolvedMembershipId <= 0) {
                try {
                  schoolDetailsRes = await this.buildGet<any>(
                    this,
                    `/school/getOneSchools/${newSchoolId}`
                  )();

                  resolvedMembershipId = Number(
                    schoolDetailsRes?.data?.membership?.id ??
                      schoolDetailsRes?.membership?.id ??
                      schoolDetailsRes?.data?.membership_id ??
                      schoolDetailsRes?.membership_id ??
                      schoolDetailsRes?.data?.membershipId ??
                      schoolDetailsRes?.membershipId ??
                      schoolDetailsRes?.data?.memberShipId ??
                      schoolDetailsRes?.memberShipId ??
                      0
                  );
                } catch (error) {
                  console.error("Failed to resolve membership id by school id:", error);
                }
              }

              if (resolvedMembershipId <= 0) {
                try {
                  const schoolBySlugRes: any = await this.buildGet<any>(
                    this,
                    `/school/getOneSchoolSlug/${slug.trim()}`
                  )();

                  resolvedMembershipId = Number(
                    schoolBySlugRes?.data?.membership?.id ??
                      schoolBySlugRes?.membership?.id ??
                      schoolBySlugRes?.data?.membership_id ??
                      schoolBySlugRes?.membership_id ??
                      schoolBySlugRes?.data?.membershipId ??
                      schoolBySlugRes?.membershipId ??
                      schoolBySlugRes?.data?.memberShipId ??
                      schoolBySlugRes?.memberShipId ??
                      0
                  );
                } catch (error) {
                  console.error("Failed to resolve membership id by school slug:", error);
                }
              }

              // Try to resolve subscription_id from backend response
              let resolvedSubscriptionId = null;
              if (schoolDetailsRes?.data?.memberPayHistory?.subscription_id) {
                resolvedSubscriptionId = schoolDetailsRes.data.memberPayHistory.subscription_id;
              } else if (schoolDetailsRes?.data?.subscription_id) {
                resolvedSubscriptionId = schoolDetailsRes.data.subscription_id;
              } else if (schoolDetailsRes?.data?.membership?.subscription_id) {
                resolvedSubscriptionId = schoolDetailsRes.data.membership.subscription_id;
              } else if (schoolDetailsRes?.memberPayHistory?.subscription_id) {
                resolvedSubscriptionId = schoolDetailsRes.memberPayHistory.subscription_id;
              } else if (schoolDetailsRes?.subscription_id) {
                resolvedSubscriptionId = schoolDetailsRes.subscription_id;
              } else if (schoolDetailsRes?.membership?.subscription_id) {
                resolvedSubscriptionId = schoolDetailsRes.membership.subscription_id;
              }

              const newSchoolObj = {
                id: newSchoolId,
                membership_id: responseAny?.data?.id, // Use the top-level id from API response as membership_id
                memberPayHistory: {
                  plan: { id: 1 },
                  subscription_id: resolvedSubscriptionId,
                  price: 0,
                },
                subscription_type: "cheque",
                is_custom_price: false,
              };

              this.setState(
                { openUpgrade: true, newSchool: newSchoolObj },
                () => {
                  this.partialCleanCheck.setOldFormData(this.getPartialCleanState());
                }
              );
            },
            () => {
              this.setState({
                postingSchool: undefined,
                submitting: undefined,
              });
            }
          );

        // Load school data
        private loadSchool = async (schoolId: number | undefined) =>
          void this.runCancellableStatefulAsync(
            this,
            {
              loading: true,
            },
            {
              loading: undefined,
            },
            async () => {
              if (schoolId !== undefined) {
                const school = await this.buildGet<
                  ISchool & 
                  {ismidseason: boolean} &
                  {isAdSurveyStatus:boolean} & 
                  {headcoach: boolean} & 
                  {status: boolean}
                >(
                  this,
                  `admin/school/${schoolId}`
                )();
                
                this.setState({
                  schoolData: school, 
                  isADschool: school?.isAdSurveyStatus
                });
                
                const MidSesonCase =
                  school?.ismidseason === true
                    ? school?.status
                    : (school as any)?.schoolMidsession === false
                    ? false
                    : true;

                this.setState(() => {
                  const newState = {
                    directors: school.directors?.filter((director:any) => 
                      director?.headcoach === false
                    )?.map((director: any) => ({
                      email: director.email ?? "",
                      adfName: director.firstName ?? "",
                      adlName: director.lastName ?? "",
                      adId: director.id ?? 0,    
                      superAdmin: (director as any).superadmin ?? 0,
                      HeadCoach: (director as any).headcoach,
                      restrictedCoaches:
                        director.restrictedCoaches?.sort() ?? [],
                      invitationStatus: director.invitationStatus ?? "",
                      invitationCount: director.invitationCount ?? 0,
                      invitationLinkUrl: director.invitationLinkUrl ?? "",
                    })),
                    imageChanged: false,
                    loadedSlug: school.slug,
                    logo1: school.logo1 || APP_LOGO_BASE64,
                    logo2: school.logo2 || APP_LOGO_BASE64,
                    name: school.name,
                    primaryColor: school.primaryColor || '#494b8f',
                    school,
                    secondaryColor: school.secondaryColor || '#ffffff',
                    slug: school.slug,
                    tagline: school.tagline,
                    templates: school.templates,
                    mascot: school?.mascot || "",
                    isMidSeason: MidSesonCase,
                    showEnable: school?.ismidseason
                  };
                  this.partialCleanCheck.setOldFormData(newState);
                  return newState;
                });
              }
            },
            () => {
              this.setState({ loading: undefined });
            }
          );

        private readonly loadCoaches = (schoolSlug: string) =>
          void this.runCancellableStatefulAsync(
            this,
            {
              loading: true,
            },
            {
              loading: undefined,
            },
            async () => {
              this.setState({
                coaches: await this.buildGetWithParams<
                  ICoach[],
                  IDirectorParams
                >(
                  this,
                  "coach"
                )({ schoolSlug }),
              });
            },
            () => {
              this.setState({ loading: undefined });
              window.alert("Failed to load teachers");
            }
          );

        private updateCreatedSchoolDirectors = async (schoolId: number) => {
          const {
            name,
            primaryColor,
            secondaryColor,
            slug,
            tagline,
            directors,
            templates,
            logo1,
            logo2,
            mainAd,
            mascot,
            isMidSeason,
            showEnable,
          } = this.state;

          const schoolTemplates = templates
            .map((template) => this.props.templates.find((t) => t.id === template.id))
            .filter((template) => template != null) as ITemplate[];

          await this.buildPut<
            ISchoolData &
            { admin: IMainAdEdit[] } &
            { status?: boolean; isMidSeason?: boolean; isAdSurveyStatus: boolean; isAdSurvey: boolean },
            void
          >(
            this,
            `school/${schoolId}`
          )({
            directors: directors
              .map(({ email, restrictedCoaches, adfName, adlName }) => ({
                email: email.trim().toLowerCase(),
                firstName: adfName,
                lastName: adlName,
                restrictedCoaches,
              }))
              .filter(({ email }) => Boolean(email)),
            logo1,
            logo2,
            admin: mainAd,
            name: name.trim(),
            primaryColor,
            secondaryColor,
            slug: slug.trim(),
            tagline: tagline.trim(),
            templates: schoolTemplates,
            isAdSurveyStatus: false,
            isAdSurvey: false,
            mascot,
            ...(showEnable ? { status: isMidSeason } : { isMidSeason }),
          });
        };

        // Update school (existing schools)
        private updateSchool: () => void = () =>
          void this.runCancellableStatefulAsync(
            this,
            {
              submitting: true,
            },
            {
              submitting: undefined,
            },
            async () => {
              const {
                name,
                primaryColor,
                secondaryColor,
                slug,
                tagline,
                directors,
                templates,
                logo1,
                logo2,
                mainAd,
                mascot, 
                isMidSeason, 
                showEnable
              } = this.state;
              const { schoolId } = this.props;
              
              const schoolTemplates = templates
                .map((template) =>
                  this.props.templates.find((t) => t.id === template.id)
                )
                .filter((template) => template != null) as ITemplate[];
                
              await this.buildPut<
                ISchoolData & 
                { admin: IMainAdEdit[] } & 
                { status?: boolean; isMidSeason?: boolean , isAdSurveyStatus: boolean, isAdSurvey: boolean}, 
                void
              >(
                this,
                `school/${schoolId}`
              )({
                directors: directors
                  .map(({ email, restrictedCoaches, adfName, adlName }) => {
                    return {
                      email: email.trim().toLowerCase(),
                      firstName: adfName,
                      lastName: adlName,
                      restrictedCoaches,
                    };
                  })
                 .filter(({ email }) => Boolean(email)),
                logo1,
                logo2,
                admin: mainAd,
                name: name.trim(),
                primaryColor,
                secondaryColor,
                slug: slug.trim(),
                tagline: tagline.trim(),
                templates: schoolTemplates,
                isAdSurveyStatus: false,
                isAdSurvey: false,
                mascot,
                ...(showEnable ? { status: isMidSeason } : { isMidSeason }),
              });
              
              await this.loadSchool(this.props.schoolId);
            },
            () => {
              this.setState({ submitting: undefined });
            }
          );

        // CONTINUE TO PART 3 FOR RENDER AND OTHER METHODS...


        // FILE: src/pages/admin/SchoolEditorPage/SchoolEditorPage.tsx
// Part 3: Render Method with Modal Integration

        
        // Helper methods continue...
        private openEditModal = (directorIndex: number) => {
          this.setState({
            editModalDirectorIndex: directorIndex,
            isEditModalOpen: true,
          });
        };

        private closeEditModal = () => {
          this.setState({
            editModalDirectorIndex: -1,
            isEditModalOpen: false,
          });
        };

        private openAdEditModal = (directorIndex: number) => {
          this.setState({
            editModalDirectorIndex: directorIndex,
            adEditModal: true,
          });
        };

        private handleRadioChange = (index: any, fname:string, lname:string, Email: any) => {
          this.setState((prevState) => ({
            directors: prevState.directors.map((director, index1) => ({
              ...director,
              superAdmin: index1 === index,
            })),
          }));
      
          const mainAdEntry: IMainAdEdit = {
            email: Email,
            restrictedCoaches: [],
            firstName: fname,
            lastName: lname,
          };
        
          this.setState({
            mainAd: [mainAdEntry],
          });
        };
      
        private closeAdEditModal = () => {
          this.setState({
            editModalDirectorIndex: -1,
            adEditModal: false,
          });
        };

        private removeField = (field: any, index: number) => {
          this.setState((prevState) =>
            update(prevState, {
              [field]: { $splice: [[index, 1]] },
            })
          );
        };

        private removeFieldOfAd = (field: any, index: number) => {
          this.setState((prevState) =>
            update(prevState, {
              [field]: { $splice: [[index, 1]] },
            })
          );
        };

        private handleDeleteDirector = (field: any, index: number, mainAd: boolean) => {
          if (mainAd) {
            alert("You cannot delete the current school admin. Please add or select a new school admin first.");
            return;
          }
          this.removeFieldOfAd(field, index);
        };

        private addDirector = () => {
          const { directors, directorEmail, adfirstName, adlastName } = this.state;
          const errors: string[] = [];
          const isDirectorEmailUnique =
            directors.find((director) => director.email === directorEmail) === undefined;
          const isDirectorEmailValid = directorEmail?.trim()
            ? EmailValidator.validate(directorEmail.trim())
            : false;
            
          if (!directorEmail?.trim()) {
            errors.push("Email cannot be blank.");
          } else if (directorEmail?.trim() && !isDirectorEmailUnique) {
            errors.push("The email is already associated with an existing director.");
          } else if (directorEmail?.trim() && !isDirectorEmailValid) {
            errors.push("Invalid email address.");
          } else if (!adfirstName?.trim()) {
            errors.push("First name cannot be blank.");
          } else if (!adlastName?.trim()) {
            errors.push("Last name cannot be blank.");
          }
        
          if (errors.length > 0) {
            window.alert(errors.join("\n"));
            return; 
          }
          
          this.setState({directorAdded: true});
          this.setState((prevState) =>
            update(prevState, {
              directorEmail: { $set: "" },
              adfirstName: { $set: "" },
              adlastName: { $set: "" },
              directors: {
                $push: [
                  {
                    email: directorEmail.trim(),
                    restrictedCoaches: [],
                    adfName: adfirstName,
                    adlName: adlastName,
                    adId: 0,
                    superAdmin: prevState.directors.length === 0 ? true : false,
                    HeadCoach: false,
                    invitationStatus: "",
                    invitationCount: 0,
                    invitationLinkUrl: "",
                  },
                ],
              },
            })
          );
        };

        private addTemplate = (templateId: number) => {
          if (this.state.templates.length >= 1) {
            return;
          }
          const template = this.props.templates.find(
            (t) => t.id === templateId
          );
          if (
            template !== undefined &&
            this.state.templates.find((t) => t.id === templateId) === undefined
          ) {
            this.setState((prevState) =>
              update(prevState, {
                templateId: { $set: -1 },
                templates: {
                  $push: [template],
                },
              })
            );
          }
        };

        private handleDirectorEmailChange = (
          e: React.ChangeEvent<HTMLInputElement>
        ) => this.setState({ directorEmail: e.target.value });

        private handleDirectorFirstName = (
          e: React.ChangeEvent<HTMLInputElement>
        ) => this.setState({ adfirstName: e.target.value });

        private handleDirectorLastName = (
          e: React.ChangeEvent<HTMLInputElement>
        ) => this.setState({ adlastName: e.target.value });

        private handleTemplateChange = (
          e: React.ChangeEvent<HTMLSelectElement>
        ) => this.addTemplate(parseInt(e.target.value, 10));

        private handleCheckAll = () => {
          const { directors, editModalDirectorIndex } = this.state;
          const directorsCopy = cloneDeep(directors);
          directorsCopy[editModalDirectorIndex].restrictedCoaches = [];

          this.setState((prevState) =>
            update(prevState, {
              directors: { $set: directorsCopy },
            })
          );
        };

        private handleUncheckAll = (coaches: ICoach[]) => {
          const { directors, editModalDirectorIndex } = this.state;
          const directorsCopy = cloneDeep(directors);

          directorsCopy[editModalDirectorIndex].restrictedCoaches = coaches
            .map((coach) => coach.id)
            .sort();

          this.setState((prevState) =>
            update(prevState, {
              directors: { $set: directorsCopy },
            })
          );
        };

        private handleCheckboxToggle = ({
          e,
          coachId,
          restrictedCoaches,
        }: {
          coachId: number;
          e: React.ChangeEvent<HTMLInputElement>;
          restrictedCoaches: number[];
        }) => {
          const { directors, editModalDirectorIndex } = this.state;
          const directorsCopy = cloneDeep(directors);
          const restrictedCoachesCopy = cloneDeep(restrictedCoaches);

          let newRestrictedCoaches: number[] = [];
          if (e.target.checked) {
            newRestrictedCoaches = restrictedCoachesCopy.filter(
              (restrictedCoach) => restrictedCoach !== coachId
            );
          } else {
            newRestrictedCoaches = restrictedCoachesCopy;
            newRestrictedCoaches.push(coachId);
          }

          directorsCopy[editModalDirectorIndex].restrictedCoaches =
            newRestrictedCoaches.sort();

          this.setState((prevState) =>
            update(prevState, {
              directors: { $set: directorsCopy },
            })
          );
        };

        private async handleResendInvite(director: any) {
          const payload = {
            email: director.email,
            firstName: director.adfName,
            lastName: director.adlName,
            schoolId: this.props.schoolId,
            invited_role: "AD",
            user_id: director.adId
          };
          try {
            await this.buildPost<typeof payload, any>(
              this,
              "/resend-invitation"
            )(payload);
            window.alert("Invite resent successfully.");
            this.loadSchool(this.props.schoolId);
          } catch (error) {
            window.alert("Failed to resend invite.");
          }
        };

        private handleCopyInviteLink = (director: any) => {
          const link = director?.invitationLinkUrl;
          if (!link) {
            alert("No invitation link found");
            return;
          }
          navigator.clipboard.writeText(link)
            .then(() => {
              alert("Invite link copied!");
            })
            .catch((err) => {
              console.error("Failed to copy: ", err);
              alert("Failed to copy link");
            });
        };

        private renderModal() {
          const {
            coaches,
            directors,
            editModalDirectorIndex,
            isEditModalOpen,
          } = this.state;
          const currentDirector = directors[editModalDirectorIndex] ?? {};

          return (
            <Modal open={isEditModalOpen} closeModal={this.closeEditModal}>
              <Grid
                style={{ height: "100%" }}
                container={true}
                direction="column"
                justifyContent="space-between"
              >
                <Grid>
                  <Box marginBottom="20px">
                    <Typography variant="h4">{MODAL_TITLE}</Typography>
                    <Typography variant="subtitle1">
                      {GET_MODAL_SUBTITLE(currentDirector.email)}
                    </Typography>
                  </Box>
                  {coaches && (
                    <Box
                      display="flex"
                      alignItems="center"
                      style={{ gap: "12px" }}
                    >
                      <Button
                        variant="outlined"
                        color="primary"
                        size="small"
                        onClick={this.handleCheckAll}
                      >
                        {MODAL_CHECK_ALL}
                      </Button>
                      <Button
                        variant="contained"
                        color="secondary"
                        size="small"
                        onClick={() => this.handleUncheckAll(coaches)}
                      >
                        {MODAL_UNCHECK_ALL}
                      </Button>
                    </Box>
                  )}
                  <Box margin="16px 0px">
                    <Typography variant="h6">
                      {MODAL_ALLOWED_COACHES}
                    </Typography>
                    <Box margin="0px 8px">
                      {coaches?.map((coach) => {
                        const { id: coachId, name } = coach;
                        const restrictedCoaches =
                          currentDirector.restrictedCoaches;
                        const isChecked = !restrictedCoaches?.includes(coachId);
                        return (
                          <Box key={coachId}>
                            <FormControlLabel
                              control={
                                <Checkbox
                                  checked={isChecked}
                                  onChange={(e) =>
                                    this.handleCheckboxToggle({
                                      coachId,
                                      e,
                                      restrictedCoaches,
                                    })
                                  }
                                />
                              }
                              label={name}
                            />
                          </Box>
                        );
                      })}
                    </Box>
                  </Box>
                </Grid>
                <Grid container={true} justifyContent="flex-end">
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={this.closeEditModal}
                  >
                    {MODAL_CLOSE}
                  </Button>
                </Grid>
              </Grid>
            </Modal>
          );
        }
        
        private EditDirectorModal() {
          const { directors, editModalDirectorIndex, adEditModal } = this.state;
          const currentDirector = directors[editModalDirectorIndex] ?? {};
          
          if (!adEditModal) {
            return null;
          }
          
          const handleFieldChange = (field: string, value: string) => {
            const updatedDirectors = [...directors];
            updatedDirectors[editModalDirectorIndex] = {
              ...updatedDirectors[editModalDirectorIndex],
              [field]: value,
            };
            this.setState({ directors: updatedDirectors });
          };
                
          const saveDirectorDetails = async () => {
            const errors = [];
            const isEmailProvided = currentDirector.email.trim() !== "";
            const isEmailValid = EmailValidator.validate(currentDirector.email.trim());
          
            if (!isEmailProvided) {
              errors.push("Email cannot be blank.");
            } else if (!isEmailValid) {
              errors.push("Invalid email format.");
            } else if (currentDirector.adfName.trim() === "") {
              errors.push("First name is required.");
            } else if (currentDirector.adlName.trim() === "") {
              errors.push("Last name is required.");
            }
            
            if (errors.length > 0) {
              window.alert(errors.join("\n"));
              return;
            }
          
            try {
              const response = await this.buildPut<any, { success: boolean; message: string; status: boolean }>(
                this,
                'user/updateUserAdmin'
              )({
                userId: currentDirector.adId ?? 0,
                email: currentDirector.email,
                firstName: currentDirector.adfName,
                lastName: currentDirector.adlName,
              });
          
              this.props.loadSchools();
          
              if (response.status === true) {
                window.alert("Director details updated successfully");
                this.setState({ adEditModal: false });
              } else {
                window.alert("Email already exists");
                this.setState({ adEditModal: false });
              }
            } catch (error) {
              console.error("Error updating director details:", error);
              window.alert("Failed to update director details.");
            }
          };
          
          return (
            <Modal className="modal-dirctor-iinner" open={adEditModal} closeModal={this.closeAdEditModal}>
              <Grid
                style={{ height: "auto" }}
                container={true}
                direction="column"
                justifyContent="space-between"
              >
                <div>
                  <div className="edit-director">
                    <h3>Edit Main Admin</h3>
                    <span onClick={this.closeAdEditModal} style={{cursor:"pointer"}}>
                      <CloseIcon /> 
                    </span>
                  </div>      
                  <div style={{ marginBottom: "16px" }}>
                    <label>Email<span style={{color:"red"}}>*</span></label>
                    <input
                      placeholder="Email"
                      type="email"
                      value={currentDirector.email || ""}
                      onChange={(e) => handleFieldChange("email", e.target.value)}
                      style={{
                        width: "100%",
                        padding: "8px",
                        borderRadius: "4px",
                        border: "1px solid #ccc",
                      }}
                    />
                  </div>
        
                  <div style={{ marginBottom: "16px" }}>
                    <label>First Name<span style={{color:"red"}}>*</span></label>
                    <input
                      placeholder="First Name"
                      type="text"
                      value={currentDirector.adfName || ""}
                      onChange={(e) => handleFieldChange("adfName", e.target.value)}
                      style={{
                        width: "100%",
                        padding: "8px",
                        borderRadius: "4px",
                        border: "1px solid #ccc",
                      }}
                    />
                  </div>
        
                  <div style={{ marginBottom: "16px" }}>
                    <label>Last Name<span style={{color:"red"}}>*</span></label>
                    <input
                      placeholder="Last Name"
                      type="text"
                      value={currentDirector.adlName || ""}
                      onChange={(e) => handleFieldChange("adlName", e.target.value)}
                      style={{
                        width: "100%",
                        padding: "8px",
                        borderRadius: "4px",
                        border: "1px solid #ccc",
                      }}
                    />
                  </div>
        
                  <div style={{ display: "flex", justifyContent: "flex-end", gap: "8px" }}>
                    <button
                      onClick={saveDirectorDetails}
                      style={{
                        padding: "8px 16px",
                        borderRadius: "4px",
                        border: "none",
                        backgroundColor: "#494b8f",
                        color: "#fff",
                      }}
                    >
                      Save
                    </button>
                  </div>
                </div>
              </Grid>
            </Modal>
          );
        }
        
        private renderDirectors() {
          const { directors, directorEmail, adfirstName, adlastName } = this.state;
          return (
            <>
              <div>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <h2 style={{ margin: 0 }}>{DIRECTORS_HEADING}</h2>
                </div>
                <div className="form-container-inner-end">
                  <input
                    value={directorEmail}
                    onChange={this.handleDirectorEmailChange}
                    placeholder="Enter email id"
                  />
                  <input
                    value={adfirstName}
                    onChange={this.handleDirectorFirstName}
                    placeholder="Enter first name"
                    required={true}
                  />
                  <input
                    value={adlastName}
                    onChange={this.handleDirectorLastName}
                    placeholder="Enter last name"
                    required={true}
                  />
                  <button type="button" onClick={this.addDirector}>
                    {DIRECTOR_ADD_EMAIL}
                  </button>
                </div>
                
                <table className="table-inner-parr" id="directorTable" style={{ width: "100%", borderCollapse: "collapse" }}>
                  {directors?.length > 0 && (
                    <thead>
                      <tr style={{ backgroundColor: "#f4f4f4" }}>
                        <th style={{width:"22%"}}>Email</th>
                        <th style={{width:"15%"}}>First Name</th>
                        <th style={{width:"15%"}}>Last Name</th>
                        <th style={{width:"13%"}}>Status</th>
                        <th style={{width:"11%"}}>Select School Admin</th>
                        <th style={{width:"25%"}}>Actions</th>
                      </tr>
                    </thead>
                  )}
                  <tbody>
                    {directors?.map((director, index) => (
                      <tr key={director.email}>
                        <td onClick={() => this.openAdEditModal(index)}>
                          <span className="directoredit-cur">{director.email}</span> 
                          <span style={{color: "red", fontWeight: "bold", fontSize: "16px"}}>
                            {director.superAdmin && "*"}
                          </span>
                        </td>
                        <td onClick={() => this.openAdEditModal(index)}>
                          <span className="directoredit-cur">{director.adfName}</span>
                        </td>
                        <td onClick={() => this.openAdEditModal(index)}>
                          <span className="directoredit-cur">{director.adlName}</span>
                        </td>
                        <td>
                          {director.adId !== 0 && (
                            <div style={{ fontSize: 12, color: "#555" }}>
                              <div><strong>Status:</strong> {director.invitationStatus === "pending" ? "Sent (Not Accepted)" : "Accepted via Invite"}</div>
                              {/* {director.invitationStatus === "Pending" && <div><strong>Count:</strong> {director.invitationCount}</div>} */}
                            </div>
                          )}
                        </td>
                        <td>
                          <input 
                            style={{marginLeft:"25px"}} 
                            type="radio" 
                            name="mainAd" 
                            value="Ad"
                            checked={director.superAdmin === true}
                            onChange={() => this.handleRadioChange(
                              index, 
                              director.adfName, 
                              director.adlName, 
                              director.email
                            )}
                          />
                        </td>
                        <td>
                          <Tooltip title={DIRECTOR_EDIT_TOOLTIP} placement="top">
                            <IconButton
                              aria-label="Edit"
                              onClick={() => this.openEditModal(index)}
                              style={{ marginRight: "8px" }}
                            >
                              <Edit />
                            </IconButton>
                          </Tooltip>
                          <Tooltip title={DIRECTOR_DELETE_TOOLTIP} placement="top">
                            <IconButton
                              aria-label="Delete"
                              onClick={() => this.handleDeleteDirector("directors", index, director.superAdmin)}
                            >
                              <Delete />
                            </IconButton>
                          </Tooltip>
                          {director.invitationStatus === "pending" && director.adId !== 0 && (
                            <>
                              <button
                                type="button"
                                onClick={() => this.handleResendInvite(director)}
                                style={{
                                  backgroundColor: "#ffffff",
                                  color: "#494b8f",
                                  border: "1px solid #494b8f",
                                  padding: "4px 8px",
                                  borderRadius: "4px",
                                  cursor: "pointer",
                                  fontSize: 12,
                                  marginRight: "5px",
                                }}
                              >
                                Resend invite
                              </button>
                              <button
                                type="button"
                                onClick={() => this.handleCopyInviteLink(director)}
                                style={{
                                  backgroundColor: "#f5f5f5",
                                  color: "#333",
                                  border: "1px solid #ccc",
                                  padding: "4px 8px",
                                  borderRadius: "4px",
                                  cursor: "pointer",
                                  fontSize: 12,
                                }}
                              >
                                Copy link
                              </button>
                            </>
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              {this.renderModal()}
              {this.EditDirectorModal()}
            </>
          );
        }

        private renderTemplates() {
          const hasAssignedTemplate = this.state.templates.length >= 1;
          return (
            <div>
              <h2>{TEMPLATES_HEADING}</h2>
              <p>{TEMPLATES_BODY}</p>
              <div>
                <select
                  style={{ 
                    width: "100%", 
                    height: "40px", 
                    borderRadius: "8px", 
                    border: "1px solid #d9d9d9" 
                  }}
                  onChange={this.handleTemplateChange}
                  disabled={hasAssignedTemplate}
                >
                  <option value={this.state.templateId} />
                  {this.props.templates
                    .filter(
                      (t) =>
                        !hasAssignedTemplate &&
                        t.ismasterTemplate === true &&
                        this.state.templates.find(
                          (localTemplate) => localTemplate.id === t.id
                        ) === undefined
                    )
                    .map((t) => (
                      <option key={t.id} value={t.id}>
                        {t.name}
                      </option>
                    ))}
                </select>
              </div>
              <List>
                {this.state.templates.map((template, index) => (
                  <ListItem
                    key={template.id}
                    divider={true}
                    className={this.props.classes.listItem}
                  >
                    <ListItemText primary={template.name} />
                    <ListItemSecondaryAction>
                      <Tooltip title={TEMPLATE_LINK_TOOLTIP} placement="left">
                        <IconButton
                          aria-label="Remove"
                          component={Link}
                          {...({
                            target: "_blank",
                            to: `/admin/templates/edit/${template.id}`,
                          } as any)}
                        >
                          <IconLink />
                        </IconButton>
                      </Tooltip>
                      <Tooltip title={TEMPLATE_DELETE_TOOLTIP} placement="left">
                        <IconButton
                          aria-label="Remove"
                          onClick={() => this.removeField("templates", index)}
                        >
                          <Delete />
                        </IconButton>
                      </Tooltip>
                    </ListItemSecondaryAction>
                  </ListItem>
                ))}
              </List>
            </div>
          );
        }

        private handleImageUploadAsync<K extends keyof ISchoolEditorState>(
          formatResult: (result: string) => Pick<ISchoolEditorState, K>
        ) {
          return this.stateInputEventHandlerAsync(async (elem) => {
            const result = await new Promise<string | void>(
              (resolve, reject) => {
                if (!elem.files) {
                  throw new Error("Element is not a file selection element.");
                } else if (!elem.files[0]) {
                  resolve();
                } else {
                  const reader = new FileReader();
                  reader.onerror = () => {
                    reject(reader.error);
                  };
                  reader.onload = () => {
                    if (typeof reader.result === "string") {
                      resolve(reader.result);
                    } else {
                      resolve();
                    }
                  };
                  reader.readAsDataURL(elem.files[0]);
                }
              }
            );
            return result ? formatResult(result) : undefined;
          });
        }

        private validHexColor(color: string) {
          return /(^#[0-9A-F]{6}$)|(^#[0-9A-F]{3}$)/i.test(color);
        }

        private canSubmit = (isNewSchool: boolean) => {
          const {
            submitting,
            name,
            slug,
            primaryColor,
            secondaryColor,
            templates,
            isMidSeason,
            directorAdded,
            mascot
          } = this.state;
          
          const missingFields: string[] = [];
          
          if (!name) {
            missingFields.push("Please provide a name.");
          } else if (!slug) { 
            missingFields.push("A slug is required.");
          } else if (isNewSchool && this.state.AllSlugs?.includes(slug)) {
            missingFields.push("Slug is not unique");
          } else if (!mascot) {
            missingFields.push("Please add a mascot."); 
          } else if (isNewSchool && !directorAdded) {
            missingFields.push("Please fill in the AD field.");
          } else if (isMidSeason === undefined) {
            missingFields.push("Is Mid Season is not selected");
          } else if (submitting !== undefined) {
            missingFields.push("Submitting is in progress");
          } else if (!this.validHexColor(primaryColor)) {
            missingFields.push("Primary Color is invalid");
          } else if (!this.validHexColor(secondaryColor)) {
            missingFields.push("Secondary Color is invalid");
          } else if (templates.length === 0) {
            missingFields.push("Please select a template.");
          }
        
          if (missingFields?.length > 0) {
            alert(missingFields.join("\n"));
            return false;
          }
          
          return true;
        };

        private readonly uniqueSlug = () => {
          const { slug, school } = this.state;
          return (
            this.props.schools.find(
              (s) =>
                s.slug.toLowerCase() === slug.toLowerCase() &&
                (school === undefined ? true : school.id !== s.id)
            ) === undefined
          );
        };
      }
    )
  )
);



// WEBPACK FOOTER //
// ./src/pages/admin/SchoolEditorPage/SchoolEditorPage.tsx